<script lang="ts">
  import { ErrorView, PageView, Alert, EntityView } from '$shared/components';
  import DatasetResult from './partials/DatasetResult.svelte';
  import { AlertOption } from '$shared/models/AlertOption';
  import type { SanctionMatchCompOption } from '$shared/models/SanctionMatchCompOption';
  import type { AlertDetailedInfo } from '$shared/models/AlertDetailedInfo';
import { EntityAction } from '$shared/constants/EntityAction';

  const DefaultActions = [EntityAction.ReVerify];

  interface Props {
    readonly?: boolean;
    reviewProcessing?: boolean;
    option: SanctionMatchCompOption;
    error?: AlertDetailedInfo | string | null;
    name?: string;
    onapprove?: (id: string) => void;
    onreject?: (id: string) => void;
    onundo?: (id: string) => void;
    onevent?: (payload: any) => void;
    onreverify?: () => void;
    onedit?: () => void;
    onclickoption?: (option: any) => void;
    onerrorclose?: () => void;
    onpreview?: (url: string) => void;
  }

  let {
    readonly = false,
    reviewProcessing = false,
    option,
    error = null,
    name = '',
    onapprove,
    onreject,
    onundo,
    onevent,
    onreverify,
    onedit,
    onclickoption,
    onerrorclose,
    onpreview
  }: Props = $props();

  const onApprove = (id: string): void => {
    onapprove?.(id);
  };

  const onReject = (id: string): void => {
    onreject?.(id);
  };

  const onUndo = (id: string): void => {
    onundo?.(id);
  };

  const onEvent = (action: string, id: string): void => {
    onevent?.({ action, id });
  };
</script>

<div class="comp-sanction-view">
  {#if option.failedError}
    <div class="sanction-alert">
      <Alert maxWidth data={option.failedError} options={AlertOption.errorAlert()} />
    </div>
  {/if}
  <PageView {name} errorMessage={error} {onerrorclose}>
    <div class="sanction-match">
      <EntityView
        isDataset
        hasCustomResult
        {readonly}
        name={option.name}
        loading={option.loading}
        processing={option.processing}
        title={option.title}
        metaInfo={option.metaInfo}
        providedInfos={option.providedInfos}
        monitoringConfig={option.monitoringConfig}
        options={option.options}
        tag={option.tag}
        showResultMatchKey={option.showResultMatchKey}
        actions={option.actions || DefaultActions}
        isNeedsReview={option.isReview}
        hasVerification
        {onreverify}
        {onedit}
        {onclickoption}
      >
        {#snippet result()}
                <div class="results" >
            {#each option.results as result}
              <DatasetResult
                {result}
                {reviewProcessing}
                reviewDisabled={option.processing}
                {readonly}
                onapprove={() => onApprove(result?.__meta?.id)}
                onreject={() => onReject(result?.__meta?.id)}
                onundo={() => onUndo(result?.__meta?.id)}
                onevent={(action) => onEvent(action, result?.__meta?.id)}
                {onpreview}
              />
            {:else}
              <ErrorView label={option.resultInfoLabel} />
            {/each}
            {#each option.oldMatches as result}
              <DatasetResult
                {result}
                {readonly}
                isRemoved
                {reviewProcessing}
                reviewDisabled={option.processing}
                hasPad={option.hasNoResult}
                onapprove={() => onApprove(result?.__meta?.id)}
                onreject={() => onReject(result?.__meta?.id)}
                onundo={() => onUndo(result?.__meta?.id)}
                onevent={(action) => onEvent(action, result?.__meta?.id)}
                {onpreview}
              />
            {/each}
          </div>
              {/snippet}
      </EntityView>
    </div>
  </PageView>
</div>

<style>
  .results {
    width: 100%;
  }
  .sanction-alert {
    margin-bottom: 24px;
  }
</style>
